import type { RouteRecordRaw } from 'vue-router';
import { DEFAULT_LAYOUT } from '@/router/base';

const menuManage: RouteRecordRaw = {
  path: '/menu-manage',
  name: '系统',
  component: DEFAULT_LAYOUT,
  meta: {
    title: '菜单配置', // 页面tab显示的名称
    icon: 'SfHome', // 菜单icon
    permission: ['*'],
    order: 100,
  },
  children: [
    {
      path: '/menu-manage',
      name: '功能',
      component: () => import('@/pages/menu-manage.vue'),
      meta: {
        title: '功能列表', // 页面tab显示的名称
        permission: ['*'],
        activeMenu: '',
        hideInMenu: true,
      },
    },
  ],
};

export default menuManage;
